import { create } from 'zustand';
import type { Platform } from './socialMediaStore';

export interface ContentIdea {
  title: string;
  description: string;
  hashtags?: string[];
  type: 'video' | 'post' | 'story' | 'reel';
  category: string;
}

interface IdeaStore {
  ideas: ContentIdea[];
  usedIdeas: Set<string>;
  addIdeas: (newIdeas: ContentIdea[]) => void;
  clearIdeas: () => void;
  isIdeaUsed: (idea: ContentIdea) => boolean;
  clearUsedIdeas: () => void;
}

export const useIdeaStore = create<IdeaStore>((set, get) => ({
  ideas: [],
  usedIdeas: new Set(),
  addIdeas: (newIdeas) => set((state) => {
    // Add new ideas and track them to avoid duplicates
    const usedIdeas = new Set(state.usedIdeas);
    newIdeas.forEach(idea => usedIdeas.add(JSON.stringify(idea)));
    
    return {
      ideas: newIdeas,
      usedIdeas
    };
  }),
  clearIdeas: () => set({ ideas: [] }),
  isIdeaUsed: (idea) => get().usedIdeas.has(JSON.stringify(idea)),
  clearUsedIdeas: () => set({ usedIdeas: new Set() })
}));